<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6" *ngIf="!isRegistered">
      <app-bs-display
        *ngIf="isPerson"
        key="UserProfile.Email"
        [valueText]="form.controls.Email?.value"
      >
      </app-bs-display>
      <bs-ng-text
        *ngIf="!isPerson"
        formControlName="Email"
        identifier="Email"
        key="UserProfile.Email"
        name="Email"
      >
      </bs-ng-text>
    </div>
    <div class="col-md-6">
      <app-bs-display
        *ngIf="isPerson && !isRegistered"
        key="UserProfile.Mobile"
        [valueText]="form.controls.Mobile?.value"
      >
      </app-bs-display>
      <bs-ng-text
        *ngIf="!isPerson || isRegistered"
        formControlName="Mobile"
        identifier="Mobile"
        key="UserProfile.Mobile"
        name="Mobile"
        [minlength]="10"
        [maxlength]="20"
        [mask]="phoneNumberMask"
      >
      </bs-ng-text>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-text
        formControlName="SecondaryMobile"
        identifier="SecondaryMobile"
        key="UserProfile.SecondaryMobile"
        name="SecondaryMobile"
        [minlength]="10"
        [maxlength]="20"
        [mask]="phoneNumberMask"
      >
      </bs-ng-text>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-text
        formControlName="PhoneNumber"
        identifier="PhoneNumber"
        key="UserProfile.PhoneNumber"
        name="PhoneNumber"
        [minlength]="10"
        [maxlength]="20"
        [mask]="phoneNumberMask"
      >
      </bs-ng-text>
    </div>
    <div class="col-md-6" *ngIf="isPerson">
      <app-bs-display
        *ngIf="isRegistered"
        key="UserProfile.Emirate"
        [valueText]="form.controls.Emirate?.value | lookup : lang"
      >
      </app-bs-display>
      <bs-ng-dropdown *ngIf="!isRegistered"
        formControlName="Emirate"
        identifier="Emirate"
        name="Emirate"
        key="UserProfile.Emirate"
        [items]="lookups.Emirates"
        [bindLabel]="defaultLookupDisplayProperty"
      >
      </bs-ng-dropdown>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-text
        formControlName="Fax"
        identifier="Fax"
        name="Fax"
        key="UserProfile.Fax"
        maxLength="200"
      >
      </bs-ng-text>
    </div>
    <div class="col-md-6">
      <bs-ng-text
        formControlName="PoBox"
        identifier="PoBox"
        name="PoBox"
        key="UserProfile.PoBox"
        maxLength="200"
      >
      </bs-ng-text>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-dropdown
        formControlName="ServiceCenter"
        identifier="ServiceCenter"
        name="ServiceCenter"
        key="UserProfile.ServiceCenter"
        [items]="lookups.ServiceCenters"
        [bindLabel]="defaultLookupDisplayProperty"
      >
      </bs-ng-dropdown>
    </div>
    <div class="col-md-6">
      <bs-ng-text
        formControlName="City"
        identifier="City"
        name="City"
        key="UserProfile.City"
        maxLength="200"
      >
      </bs-ng-text>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-text
        formControlName="Area"
        identifier="Area"
        name="Area"
        key="UserProfile.Area"
        maxLength="200"
      >
      </bs-ng-text>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-text
        formControlName="Street"
        identifier="Street"
        name="Street"
        key="UserProfile.Street"
        maxLength="200"
      >
      </bs-ng-text>
    </div>
    <div class="col-md-6">
      <bs-ng-dropdown
        formControlName="PreferedLanguage"
        identifier="PreferedLanguage"
        name="PreferedLanguage"
        key="UserProfile.PreferedLanguage"
        [items]="lookups.Languages"
        [bindLabel]="defaultLookupDisplayProperty"
      >
      </bs-ng-dropdown>
    </div>
    <div class="col-md-6">
      <bs-ng-textarea
        formControlName="Address"
        identifier="Address"
        key="UserProfile.Address"
        name="Address"
        maxLength="500"
      >
      </bs-ng-textarea>
    </div>
    <div class="col-md-6" *ngIf="isRegistered">
      <bs-ng-dropdown
        formControlName="NotificationTypes"
        identifier="NotificationTypes"
        key="UserProfile.NotificationTypes"
        name="NotificationTypes"
        [items]="lookups.NotificationTypes"
        [bindLabel]="defaultLookupDisplayProperty"
        [searchable]="true"
        [multiple]="true"
        [closeOnSelect]="false"
      >
      </bs-ng-dropdown>
    </div>
  </div>
  <div class="row" *ngIf="!isRegistered">
    <div class="col-md-12">
      <bs-ng-checkbox
        formControlName="TermsAndConditions"
        identifier="TermsAndConditions"
        key="UserProfile.TermsAndConditions"
        name="TermsAndConditions"
        [url]="'https://www.moccae.gov.ae/en/privacy-policy.aspx'"
      >
      </bs-ng-checkbox>
    </div>
  </div>
</form>
